import { render, staticRenderFns } from "./group-column.md?vue&type=template&id=08dcaaae&"
import script from "./group-column.md?vue&type=script&lang=js&"
export * from "./group-column.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08dcaaae')) {
      api.createRecord('08dcaaae', component.options)
    } else {
      api.reload('08dcaaae', component.options)
    }
    module.hot.accept("./group-column.md?vue&type=template&id=08dcaaae&", function () {
      api.rerender('08dcaaae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Column/group-column.md"
export default component.exports